"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../hoc/compose');

var displayNames = require('./displayNames');

var Button = require('./button.js');

var ArrowLeftSymbol = require('./arrowLeft.svg.js');

var HeaderBackButton = function HeaderBackButton(_ref) {
  var automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    automationId: automationId,
    dataHook: dataHook,
    className: "btn-header-back btn-header btn-back",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ArrowLeftSymbol, null));
};

HeaderBackButton.displayName = displayNames.HEADER_BACK_BUTTON;
HeaderBackButton.propTypes = {
  onClick: PropTypes.func
};
module.exports = compose(HeaderBackButton);